import { customType } from 'drizzle-orm/pg-core'

/**
 * Custom PostgreSQL tstzrange type for Drizzle ORM
 * This type represents a timestamp with timezone range
 */
export const tstzrange = customType<{
  data: string | null
  driverData: string
}>({
  dataType() {
    return 'tstzrange'
  },
  toDriver(value: string | null): string {
    return value ?? ''
  },
  fromDriver(value: string): string | null {
    return value || null
  },
})
